/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagComputedFunctionAssign } from '../../models/tag-computed-function-assign';

export interface AssignComputedTagFunction$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  tagUid: string;
  
    /**
     * Body to assign a function to a computed tag
     */
    body: TagComputedFunctionAssign
}

export function assignComputedTagFunction(http: HttpClient, rootUrl: string, params: AssignComputedTagFunction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, assignComputedTagFunction.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('tagUid', params.tagUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

assignComputedTagFunction.PATH = '/custom/stations/{uid}/tags-computed-function/{tagUid}';
